import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Feature, Module, Permission } from '@core/configs/role';
import { RoleService, UserProfileService } from '~/app/core/services';

@Component({
  selector: 'app-nav-tab-bar',
  templateUrl: './nav-tab-bar.component.html',
  styleUrls: ['./nav-tab-bar.component.scss'],
})
export class NavTabBarComponent implements OnInit {
  tabs = [];
  moduleId;
  constructor(
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router,
    private userProfile: UserProfileService
  ) {}

  ngOnInit(): void {
    this.moduleId = this.route.snapshot.data.module_id;
    this.tabs = this.route.snapshot.data.tabs;
    const alertModule = this.route.snapshot.data.alertModule;
    if (this.moduleId) {
      for (const tab of this.tabs) {
        tab.access = this.roleService.accessFeature(
          tab.feature_id,
          this.moduleId
        );
        if (this.route.children.length === 0 && tab.access) {
          this.router.navigate([this.router.url, tab.link]);
        }
      }
    }
    if (alertModule) {
      this.tabs.forEach(tab => {
        if(tab.link === 'validation') {
          // if(this.userProfile.hasTruckingPersona() || this.userProfile.hasCarrierPersona()) {
            if(this.roleService.accessFeature(Feature.ALERT_VALIDATION, Module.ALERT, Permission.VIEW)) {
              tab.access = true;
            }
          // }
        }
      })
    }

    // if (alertModule) {
    //   this.tabs.forEach((tab) => {
    //     if (
    //       tab.link === 'validation' &&
    //       (this.userProfile.hasTruckingPersona() ||
    //         this.userProfile.hasCarrierPersona()) &&
    //       this.roleService.accessFeature(
    //         Feature.ALERT_VALIDATION,
    //         Module.ALERT,
    //         Permission.VIEW
    //       )
    //     ) {
    //       tab.access = true;
    //     }
    //   });
    // }
  }
}
